import React from 'react';
import HtmlForm from "../HtmlForm";

const HtmlSubFormField = (props) => {

    return (<>
        <HtmlForm
            form={props.form}
            fields={props.field.subFields}
            onChange={props.onChange}
            errors={props.errors}
            values={props.values}
        />
    </>);
};

HtmlSubFormField.propTypes = {};

HtmlSubFormField.defaultProps = {};

export default HtmlSubFormField;
